const getConfig = () => {
  // const env = process.env.REACT_APP_ENV || 'franklin';
  // const env = process.env.REACT_APP_ENV || 'ajith';
  const env = process.env.REACT_APP_ENV || 'alpha1';
  // const env = process.env.REACT_APP_ENV || 'kanish';
  // const env = process.env.REACT_APP_ENV || 'hari';
  // const env = process.env.REACT_APP_ENV || 'advaith';
  // const env = process.env.REACT_APP_ENV || 'default';
  //   # For default/ids-beta - update the homepage to /ids-beta/
  // # For alpha2 - update the homepage to /alpha2/
  //   # For alpha3 - update the homepage to /alpha3/ in package.json
  // const env = process.env.REACT_APP_ENV || 'alpha2';
  // const env = process.env.REACT_APP_ENV || 'alpha3';
  // const env = process.env.REACT_APP_ENV || 'naresh';
  // const env = process.env.REACT_APP_ENV || "nitin";
  // const env = process.env.REACT_APP_ENV || 'tejas';
  // const env = process.env.REACT_APP_ENV || 'default_australia';
  // const env = process.env.REACT_APP_ENV || 'default_europe';

  const configs = {
    default: {
      homepage: "/ids-beta",
      backend: "https://x.cloobot.ai/ids-beta/backend",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "https://x.cloobot.ai/ids-beta/#",
    },
    alpha1: {
      homepage: "/ids-beta",
      backend: "https://alpha.cloobot.ai/ids-beta/backend",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "https://alpha.cloobot.ai/ids-beta/#",
    },
    alpha2: {
      homepage: "/alpha2",
      // backend: 'https://alpha.cloobot.ai/alpha2/backend',
      backend: "https://alpha.cloobot.ai/ids-beta/backend", // Using ids-beta backend for alpha2 as well
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "https://alpha.cloobot.ai/alpha2/#",
    },
    alpha3: {
      homepage: "/alpha3",
      backend: "https://alpha.cloobot.ai/alpha3/backend",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "https://alpha.cloobot.ai/alpha3/#",
    },
    ajith: {
      homepage: "/ids-beta",
      backend: "http://quote.cloobot.ai:5001",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    franklin: {
      homepage: "/ids-beta",
      backend: "http://34.14.164.2:5000",
      // backend: 'http://quote.cloobot.ai:5000',
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    nitin: {
      homepage: "/ids-beta",
      backend: "http://34.14.164.2:5012",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    hari: {
      homepage: "/ids-beta",
      backend: "http://34.14.164.2:5008",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3001/ids-beta/#",
    },
    kanish: {
      homepage: "/ids-beta",
      backend: "http://34.14.164.2:5011",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    advaith: {
      homepage: "/ids-beta",
      backend: "http://quote.cloobot.ai:5007",
      // backend: 'http://34.14.164.2:5007',
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    naresh: {
      homepage: "/alpha3",
      backend: "https://alpha.cloobot.ai/ids-beta/backend",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "https://alpha.cloobot.ai/alpha3/#",
    },
    tejas: {
      homepage: "/ids-beta",
      backend: "http://quote.cloobot.ai:5013",
      microservice: "https://microservice.cloobot.ai/configuration-script",
      tabUrl: "http://localhost:3000/ids-beta/#",
    },
    default_australia: {
      homepage: "/ids-beta",
      backend: "https://au.cloobot.ai/ids-beta/backend",
      microservice: null, // Assuming microservice is not used for this environment
      tabUrl: "https://au.cloobot.ai/ids-beta/#",
    },
    default_europe: {
      homepage: "/ids-beta",
      backend: "https://agent.cloobot.ai/ids-beta/backend",
      microservice: null, // Same as Australia: microservice is not used for this environment
      tabUrl: "https://agent.cloobot.ai/ids-beta/#",
    },
  };

  return configs[env] || configs.default;
};

export const config = getConfig();
